import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { EventCartProvider } from "@/context/EventCartContext";

import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Artists from "@/pages/Artists";
import Shows from "@/pages/Shows";
import RequestQuote from "@/pages/RequestQuote";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import ArtistDetail from "@/pages/ArtistDetail";
import MyRequests from "@/pages/MyRequests";
import QuotePublic from "@/pages/QuotePublic";
import PaymentReturn from "@/pages/PaymentReturn";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Apply from "@/pages/Apply";
import Portfolio from "@/pages/Portfolio";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";
import Terms from "@/pages/Terms";

import { I18nProvider } from "@/context/I18nContext";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import VisitTracker from "@/components/VisitTracker";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <I18nProvider>
            <EventCartProvider>
            <Nav />
            <VisitTracker />
            <WhatsAppFloat />
            <CookieBanner />
            <Toaster
              theme="dark"
              position="top-center"
              toastOptions={{
                style: {
                  background: "#141210",
                  border: "1px solid rgba(229,169,60,0.4)",
                  color: "#F7F4EE",
                },
              }}
            />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/artisti" element={<Artists />} />
              <Route path="/artisti/:id" element={<ArtistDetail />} />
              <Route path="/spettacoli" element={<Shows />} />
              <Route path="/richiedi" element={<RequestQuote />} />
              <Route path="/le-mie-richieste" element={<MyRequests />} />
              <Route path="/preventivo/:token" element={<QuotePublic />} />
              <Route path="/pagamento/success" element={<PaymentReturn />} />
              <Route path="/chi-siamo" element={<About />} />
              <Route path="/servizi" element={<Services />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/candidati" element={<Apply />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookie" element={<Cookies />} />
              <Route path="/termini" element={<Terms />} />
            </Routes>
            </EventCartProvider>
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
